import { render } from "./SeoStructuredData.vue?vue&type=template&id=9d80bfd2&ts=true"
import script from "./SeoStructuredData.ts?vue&type=script&lang=ts&external"
export * from "./SeoStructuredData.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__